var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "#BABDBE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90909 0.800049H3.18182C2.65364 0.800049 2.20182 1.15005 2.01091 1.65405L0.0890909 6.58905C0.0318182 6.75005 0 6.91805 0 7.10005V8.50005C0 9.27005 0.572727 9.90005 1.27273 9.90005H5.28818L4.68364 13.099L4.66455 13.323C4.66455 13.61 4.77273 13.876 4.94455 14.065L5.61909 14.8L9.81273 10.187C10.0418 9.93505 10.1818 9.58505 10.1818 9.20005V2.20005C10.1818 1.43005 9.60909 0.800049 8.90909 0.800049ZM11.4545 0.800049V9.20005H14V0.800049H11.4545Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeIcon);
export default __webpack_public_path__ + "static/media/dislike-icon.965219bf.svg";
export { ForwardRef as ReactComponent };